/**
 * Colores de eventos del widget de Calendario: antes el color estaba fijo en
 * CalendarWidget.js (siempre rojo). Ahora cada evento puede traer su propio `color`
 * (hex), con estos defaults según cómo se haya agregado, para distinguir de un
 * vistazo el origen (ej. feriados oficiales vs. campañas importadas desde Excel).
 */

// Mismo rojo que se usaba antes de que el color fuera personalizable (mantiene el
// aspecto de los calendarios ya armados, que no tienen `color` guardado).
export const DEFAULT_EVENT_COLOR = '#ef5350';
// Azul, para diferenciar a simple vista los eventos importados desde Excel.
export const EXCEL_IMPORT_DEFAULT_COLOR = '#42a5f5';

const HEX_COLOR_RE = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

/** Blanco o negro según el brillo del color de fondo, para que el texto siempre se lea. */
export function contrastTextColor(hex) {
  const match = HEX_COLOR_RE.exec(hex || '');
  if (!match) return '#fff';
  const [r, g, b] = [match[1], match[2], match[3]].map((h) => parseInt(h, 16));
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#000' : '#fff';
}
